import { RemoteResetPasswordCognito } from 'infra/http/cognito/remote-reset-password-cognito'
import { ResetPasswordService } from 'infra/services/reset-password-service'

export const makeResetPasswordService = () => new ResetPasswordService(new RemoteResetPasswordCognito())
